
import Column from "@able/react/dist/Column";
import { TableHeadBarType } from '../types';
import { TableHeaderProvider } from './TableContext';
import TableMessage from './TableMessage';
import TableTitle from './TableTitle';

const TableHeadBar = (props: TableHeadBarType) => {
    const { tableMessageTitle, tableMessageDescription } = props;

    return (
        <TableHeaderProvider {...props}>
            <div className='ted-ui-TableHeader'>
                <TableTitle />
                {(tableMessageTitle || tableMessageDescription) && <Column bmd={8}>
                    <TableMessage />
                </Column>}
            </div>
        </TableHeaderProvider>
    )
}

export default TableHeadBar